import axios from "axios";

class ApiService {
  // Method to handle API calls
  static async getDataWithParams(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = `${url}?${queryString}`;

    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(fullUrl, { headers });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
* Post data to a URL with a JSON body
* @param {string} url - The API endpoint URL
* @param {Object} body - The payload to send in the POST request
*/
  static async postData(url, body = {}) {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
   * Post data to a URL with FormData
   * @param {string} url - The API endpoint URL
   * @param {FormData} formData - FormData to send in the POST request
   */
  static async postFormData(url, data) {
    const token = localStorage.getItem('token');
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      // If the server returned an error response with data, return it so callers can inspect
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  }

  // DELETE
  static async deletePost(url = {}) {
    const token = localStorage.getItem('token');
    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'Delete',
        headers: headers
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      } else {
        // alert("Xóa thành công")
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

  /**
   * Put data to a URL with a JSON body
   * @param {string} url - The API endpoint URL
   * @param {Object} body - The payload to send in the PUT request
   */
  static async putData(url, body = {}) {
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const text = await response.text();
      return text ? JSON.parse(text) : {};
    } catch (error) {
      throw error;
    }
  }

}

export default ApiService;
